export default class Utils {
    static timer_id = null;

    static loading(show = true, delay = 500) {
        let loading = document.getElementById('loading');
        if (!loading) {
            return;
        }

        if (Utils.timer_id) {
            clearTimeout(Utils.timer_id);
            Utils.timer_id = null;
        }

        if (show) {
            if (delay > 0) {
                Utils.timer_id = setTimeout(() => {
                    Utils.timer_id = null;
                    loading.style.display = 'block';
                }, delay);
            } else {
                Utils.timer_id = null;
                loading.style.display = 'block';
            }
        } else {
            loading.style.display = 'none';
        }
    }

    static nl2br(str) {
        str = str.replace(/\r\n/g, '<br />');
        str = str.replace(/(\n|\r)/g, '<br />');
        return str;
    }

    static copyClipboard(str, target_query) {
        var newElement = document.createElement('textarea');
        newElement.innerHTML = str;

        if (!target_query) {
            const target = document.querySelector('body');
            target.appendChild(newElement);
        } else {
            const target = document.querySelector(target_query);
            target.appendChild(newElement);
        }

        newElement.select();
        document.execCommand('copy');
        newElement.remove();
    }

    static replace_all(string, target, replacement) {
        var result = '';
        var offset = 0;
        var target_length = target.length;
        if (target_length === 0) {
            for (var i = 0, c = string.length; i < c; i++) {
                result += string[i];
                result += replacement;
            }
            if (result.length) {
                return result.substring(0, result.length - replacement.length);
            }
            return result;
        }
        do {
            var i = string.indexOf(target, offset);
            if (i === -1) {
                result += string.substring(offset);
                return result;
            }
            result += string.substring(offset, i);
            result += replacement;
            offset = i + target_length;
        } while (true);
    }
}
